"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarsUniversity = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectCard_1 = require("../../inputs/SelectCard");
const SelectOption_1 = require("../../inputs/SelectOption");
const CardName_1 = require("../../CardName");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const CardRenderer_1 = require("../render/CardRenderer");
class MarsUniversity extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MARS_UNIVERSITY,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 8,
            metadata: {
                cardNumber: '073',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When you play a Science tag, including this, you may discard a card from hand to draw a card.', (eb) => {
                        eb.science().played.startEffect.minus().cards(1).nbsp().plus().cards(1);
                    });
                }),
                victoryPoints: 1,
            },
        });
    }
    onCardPlayed(player, card) {
        if (!player.cardIsInEffect(this.name))
            return;
        const scienceTags = card.tags.filter((tag) => tag === Tags_1.Tags.SCIENCE).length;
        for (let i = 0; i < scienceTags; i++) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                if (player.cardsInHand.length === 0)
                    return undefined;
                return new OrOptions_1.OrOptions(new SelectCard_1.SelectCard('Select a card to discard', 'Discard', player.cardsInHand, (foundCards) => {
                    player.cardsInHand.splice(player.cardsInHand.indexOf(foundCards[0]), 1);
                    player.game.dealer.discard(foundCards[0]);
                    player.game.log('${0} is using their ${1} effect to discard and draw a card.', (b) => b.player(player).card(this));
                    player.game.log('You discarded ${0}', (b) => b.card(foundCards[0]), { reservedFor: player });
                    player.drawCard();
                    return undefined;
                }), new SelectOption_1.SelectOption('Do nothing', 'Confirm', () => {
                    return undefined;
                }));
            }), DeferredAction_1.Priority.DISCARD_BEFORE_DRAW);
        }
        return undefined;
    }
    play() {
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.MarsUniversity = MarsUniversity;
//# sourceMappingURL=MarsUniversity.js.map